import React, { useState } from 'react';

function Tabs() {
  const [activeTab, setActiveTab] = useState('notification');

  const tabs = [
    {
      id: 'notification',
      items: [
        { date: '24 Jun 2026', content: 'Tender call notice of Regulated Market Committee , Nilgiri', link: 'https://balasore.odisha.gov.in/en/tender/tender-call-notice-regulated-market-committee-nilgiri' },
        { date: '08 Jun 2026', content: 'This is regarding corrigendum notice of ITDA, Nilgiri', link: 'https://balasore.odisha.gov.in/en/tender/regarding-corrigendum-notice-itda-nilgiri' },
        { date: '05 Jun 2026', content: 'This is regarding walk in interview for engagement of guest faculties under govt upgraded higher secondary school, Dublagadi, Balasore', link: 'https://balasore.odisha.gov.in/en/notice/recruitment/regarding-walk-interview-engagement-guest-faculties-under-govt-upgraded-higher' },
        { date: '04 Jun 2026', content: 'Tender call notice regarding supply of uniform and other accessories for the OAV, Jamudhia, Nilgiri, Balasore', link: 'https://balasore.odisha.gov.in/en/tender/tender-call-notice-regarding-supply-uniform-and-other-accessories-oav-jamudhia-nilgiri' },
        { date: '04 Jun 2026', content: 'Tender call notice for plantation of Matured trees under National clean air programme of Balasore Municipality', link: 'https://balasore.odisha.gov.in/en/tender/tender-call-notice-plantation-matured-trees-under-national-clean-air-programme-balasore' },
        { date: '04 Jun 2026', content: 'Tender call notice regarding laboratory Chemicals, Reagents and consumables of FMMCH, Balasore for year 2026-27', link: 'https://balasore.odisha.gov.in/en/tender/tender-call-notice-regarding-laboratory-chemicals-reagents-and-consumables-fmmch-balasore' },
      ],
      viewMoreLink: 'https://balasore.odisha.gov.in/en/what-s-new'
    },
    {
      id: 'tender',
      items: [
        { date: '08 Jul 2026', content: 'Tender call notice regarding House Keeping and Sanitary items for FMMCH, Balasore', link: 'https://balasore.odisha.gov.in/en/tender/tender-call-notice-regarding-house-keeping-and-sanitary-items-fmmch-balasore' },
        { date: '06 Jul 2026', content: 'Tender call notice regarding laboratory Chemicals, Reagents and consumables of FMMCH, Balasore', link: 'https://balasore.odisha.gov.in/en/tender/tender-call-notice-regarding-laboratory-chemicals-reagents-and-consumables-fmmch-balasore' },
        { date: '03 Jul 2026', content: 'Tender call notice regarding Medicine and Medical consumables items for FMMCH, Balasore', link: 'https://balasore.odisha.gov.in/en/tender/tender-call-notice-regarding-medicine-and-medical-consumables-items-fmmch-balasore' },
        { date: '02 Jul 2026', content: 'Quotation Call Notice for light transport passenger vehicle for FMMCH, Balasore', link: 'https://balasore.odisha.gov.in/en/tender/quotation-call-notice-light-transport-passenger-vehicle-fmmch-balasore' },
        { date: '24 Jun 2026', content: 'Tender call notice of Regulated Market Committee , Nilgiri', link: 'https://balasore.odisha.gov.in/en/tender/tender-call-notice-regulated-market-committee-nilgiri' },
        { date: '22 Jun 2026', content: 'e-Procurement tender call notice of ITDA, Nilgiri', link: 'https://balasore.odisha.gov.in/en/tender/e-procurement-tender-call-notice-itda-nilgiri' },
      ],
      viewMoreLink: 'https://balasore.odisha.gov.in/en/tender'
    },
    {
      id: 'recruitment',
      items: [
        { date: '05 Jun 2026', content: 'This is regarding walk in interview for engagement of guest faculties under govt upgraded higher secondary school, Dublagadi, Balasore', link: 'https://balasore.odisha.gov.in//recruitment/regarding-walk-interview-engagement-guest-faculties-under-govt-upgraded-higher' },
        { date: '08 Apr 2026', content: 'This is regarding advertisement for the post of Counsellor in the Court of the Judge Family Court, Balasore', link: 'https://balasore.odisha.gov.in/en/recruitment/regarding-advertisement-post-counsellor-court-judge-family-court-balasore' },
        { date: '09 Mar 2026', content: 'This is regarding empanelment of contract/part time teachers for different OAVS of Balasore district', link: 'https://balasore.odisha.gov.in/en/recruitment/regarding-empanelment-contractpart-time-teachers-different-oavs-balasore-district' },
        { date: '02 Mar 2026', content: 'This is regarding invitation of objection with database of DPMU, Balasore', link: 'https://balasore.odisha.gov.in/en/recruitment/regarding-invitation-objection-database-dpmu-balasore' },
        { date: '11 Dec 2025', content: 'Objection invitation along with provisional database for empanelment of Yoga Instructor under NHM', link: 'https://balasore.odisha.gov.in/en/recruitment/objection-invitation-along-provisional-database-empanelment-yoga-instructor-under-nhm' },
        { date: '23 Oct 2025', content: 'This is regarding recruitment of Facilitator for DAESI programme for 2025-26', link: 'https://balasore.odisha.gov.in/en/recruitment/regarding-recruitment-facilitator-daesi-programme-202526' },
      ],
      viewMoreLink: 'https://balasore.odisha.gov.in/or/notice/recruitment'
    },
    {
      id: 'result',
      items: [
        { date: '31 Mar 2026', content: 'Merit and Waiting list of Class VI,VII, VIII,IX of OAV-Soro', link: 'https://balasore.odisha.gov.in/en/results/merit-and-waiting-list-class-vivii-viiiix-oav-soro' },
        { date: '31 Mar 2026', content: 'Merit and Waiting list of Class VI,VII, IX of OAV-Simulia', link: 'https://balasore.odisha.gov.in/en/results/merit-and-waiting-list-class-vivii-ix-oav-simulia' },
        { date: '31 Mar 2026', content: 'Merit and Waiting list of Class VI,VII,IX of OAV-Sadar', link: 'https://balasore.odisha.gov.in/en/results/merit-and-waiting-list-class-viviiix-oav-sadar' },
        { date: '31 Mar 2026', content: 'Merit and Waiting list of Class VI,VII, VIII,IX of OAV-Remuna', link: 'https://balasore.odisha.gov.in/en/results/merit-and-waiting-list-class-vivii-viiiix-oav-remuna' },
        { date: '31 Mar 2026', content: 'Merit and Waiting list of Class VI,VII, VIII,IX of OAV-Oupada', link: 'https://balasore.odisha.gov.in/en/results/merit-and-waiting-list-class-vivii-viiiix-oav-oupada' },
        { date: '31 Mar 2026', content: 'Merit and Waiting list of Class VI,VII, VIII,IX of OAV-Nilgiri', link: 'https://balasore.odisha.gov.in/en/results/merit-and-waiting-list-class-vivii-viiiix-oav-nilgiri' },
      ],
      viewMoreLink: 'https://balasore.odisha.gov.in/or/notice/results'
    },
    {
      id: 'advertisement',
      items: [
        { date: '05 Dec 2025', content: 'Advertisement for recruitment of support staff of 100 seated Girls Hostel of OAV Sutei, Remuna', link: 'https://balasore.odisha.gov.in/en/advertisement/advertisement-recruitment-support-staff-100-seated-girls-hostel-oav-suteiremuna' },
        { date: '24 Nov 2025', content: 'Applications are invited from retired employees to fill the vacancies in the Balasore District Judge office', link: 'https://balasore.odisha.gov.in/en/advertisement/applications-are-invited-retired-employees-fill-vacancies-balasore-district-judge' },
        { date: '05 Nov 2025', content: 'Advertisement for engagement of legal Retainer in the office of DEO Cum DPC, SS, Balasore', link: 'https://balasore.odisha.gov.in/en/advertisement/advertisement-engagement-legal-retainer-office-deo-cum-dpc-ss-balasore' },
        { date: '04 Oct 2025', content: 'EOI for District ombudsperson under MGNREGS of Zilla Parishad,Balasore', link: 'https://balasore.odisha.gov.in/en/advertisement/eoi-district-ombudsperson-under-mgnregs-zilla-parishadbalasore' },
        { date: '13 Sep 2025', content: 'Corrigendum to advt no-13561 dtd-25.08.25 regarding the walk in interview for Yoga Instructor under NHM', link: 'https://balasore.odisha.gov.in/en/advertisement/corrigendum-advt-no-13561-dtd-250825-regarding-walk-interview-yoga-instructor-under' },
        { date: '06 Sep 2025', content: 'Advertisement for recruitment of subject matter specialists in agriculture under ECRICC project', link: 'https://balasore.odisha.gov.in/en/advertisement/advertisement-recruitment-subject-matter-specialists-agriculture-under-ecricc-project' },
      ],
      viewMoreLink: 'https://balasore.odisha.gov.in/or/notices/advertisement'
    }
  ];

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  return (
    <div className="kcontainer">
      <h2 className="whats-new-heading">What's New</h2>
      
      <div className="main-content-wrapper">
        <div className="tabs">
          <div className="tab-buttons">
            {tabs.map(tab => (
              <button
                key={tab.id}
                className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
                onClick={() => handleTabChange(tab.id)}
              >
                {tab.id.charAt(0).toUpperCase() + tab.id.slice(1)}
              </button>
            ))}
          </div>

          <div className="tab-content-container">
            {tabs.map(tab => (
              <div
                key={tab.id}
                className={`tab-content ${activeTab === tab.id ? 'active' : ''}`}
              >
                {tab.items.map((item, index) => (
                  <div className="tab-item" key={index}>
                    <p>
                      <strong>{item.date}</strong> - 
                      {item.link ? (
                        <a href={item.link} target="_blank" rel="noopener noreferrer">{item.content}</a>
                      ) : (
                        item.content
                      )}
                    </p>
                  </div>
                ))}
                <a href={tab.viewMoreLink} className="view-more" target="_blank" rel="noopener noreferrer">
                  View More
                </a>
              </div>
            ))}
          </div>
        </div>
        
        <div className="geographic-location-card">
          <div className="geo-header">Geographic Location</div>
          <div className="geo-map-container">
            <img 
              src="https://balasore.odisha.gov.in/sites/default/files/styles/330_330/public/2023-06/balasore.png?itok=Tarccy5f" 
              alt="Balasore District Map"
              className="geo-map-image"
            />
          </div>
          <div className="geo-area">Area : 3,806.00 sq.km</div>
          <a
  href="https://balasore.odisha.gov.in/en/district-geographical-location/geographic-location"
  target="_blank"
  rel="noopener noreferrer"
  className="geo-locate-btn"
>
  <svg
    className="geo-pin-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
  </svg>

  Locate on Map
</a>

        </div>
      </div>

      <style>{`
        /* Styles scoped to Tabs component */
        .kcontainer {
          font-family: Arial, sans-serif;
          margin: 0;
          padding: 20px;
          background: radial-gradient(circle at right, #B3E5FC, #FFFFFF);
          .geo-area {
            font-size: 14px;
            padding: 10px 15px;
          }

          .geo-locate-btn {
            font-size: 15px;
            padding: 10px 15px;
          }
        }

        .whats-new-heading {
          color: #003366;
          font-weight: 700;
          text-align: center;
          font-size: 32px;
          margin-bottom: 30px;
          padding-bottom: 15px;
          letter-spacing: 0.6px;
          background-image: linear-gradient(to right, transparent, #003366, transparent);
          background-size: 120px 2px;
          background-repeat: no-repeat;
          background-position: center bottom;
          text-shadow: 0 0 6px rgba(0, 51, 102, 0.2);
        }

        .main-content-wrapper {
          display: flex;
          gap: 30px;
          max-width: 1400px;
          margin: 0 auto;
          align-items: flex-start;
          flex-wrap: wrap;
        }

        .tabs {
          background: white;
          border-radius: 15px;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
          overflow: hidden;
          flex: 1 1 500px;
          min-width: 500px;
          display: flex;
          flex-direction: column;
          height: 460px;
        }

        .tab-buttons {
          display: flex;
          justify-content: space-between;
          padding: 10px;
          border-bottom: 1px solid #ddd;
          overflow-x: auto;
          flex-wrap: nowrap;
          flex-shrink: 0;
        }

        .tab-buttons button {
          flex: 1;
          margin: 0 5px;
          padding: 10px 15px;
          cursor: pointer;
          border: none;
          background: #f9f9f9;
          font-size: 14px;
          font-weight: bold;
          color: #003366;
          text-align: center;
          border-radius: 20px;
          transition: background-color 0.3s ease, color 0.3s ease;
        }

        .tab-buttons button.active {
          background: #003366;
          color: white;
        }

        .tab-content-container {
          height: 320px;
          flex: 0 0 320px;
          overflow: hidden;
          padding: 15px;
          background: white;
          position: relative;
        }

        .tab-content {
          display: none;
          position: relative;
          overflow: hidden;
          height: 100%;
        }

        .tab-content.active {
          display: block;
          overflow-y: auto;
          padding-bottom: 52px;
        }

        .tab-item {
          margin-bottom: 15px;
          border-bottom: 1px solid #ddd;
          padding-bottom: 10px;
        }

        .tab-item p {
          margin: 0;
        }

        .tab-item p strong {
          color: #003366;
        }

        .tab-item a {
          color: #051525;
          text-decoration: none;
          transition: color 0.3s ease, text-decoration 0.3s ease;
        }

        .tab-item a:hover {
          color: #00509e;
          text-decoration: none;
        }

        .view-more {
          display: block;
          position: absolute;
          bottom: 10px;
          left: 15px;
          padding: 8px 15px;
          background-color: #003366;
          color: white;
          text-decoration: none;
          border-radius: 20px;
          font-size: 14px;
          text-align: center;
        }

        .view-more:hover,
        .view-more:focus,
        .view-more:focus-visible {
          background-color: #00509e;
          color: white;
          text-decoration: none;
        }

        @keyframes scroll-up {
          0% {
            transform: translateY(100%);
          }
          100% {
            transform: translateY(-100%);
          }
        }

        .tab-content.active .tab-item {
          animation: scroll-up 10s linear infinite;
        }

        /* Geographic Location Card Styles */
        .geographic-location-card {
          flex: 0 0 400px;
          background: linear-gradient(to bottom, #E3F2FD, #FFFFFF);
          border-radius: 15px;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
          overflow: hidden;
          display: flex;
          flex-direction: column;
          min-width: 350px;
          height: 460px;
        }

        .geo-header {
          background: linear-gradient(135deg, #1976D2, #2196F3);
          color: white;
          padding: 18px 25px;
          font-size: 22px;
          font-weight: bold;
          text-align: left;
          flex-shrink: 0;
        }

        .geo-map-container {
          position: relative;
          flex: 1 1 auto;
          min-height: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 18px;
          background: #F5F5F5;
          overflow: hidden;
        }

        .geo-map-image {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
        }

        .geo-area {
          background: white;
          padding: 15px 25px;
          text-align: center;
          font-size: 18px;
          font-weight: 600;
          color: #333;
          border-top: 1px solid #ddd;
          flex-shrink: 0;
        }

        .geo-locate-btn {
          background: linear-gradient(135deg, #0D47A1, #1565C0);
          color: white;
          border: none;
          padding: 15px 25px;
          font-size: 18px;
          font-weight: bold;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          transition: background 0.3s ease;
          border-bottom-left-radius: 15px;
          border-bottom-right-radius: 15px;
          flex-shrink: 0;
           text-decoration: none;
        }

        .geo-locate-btn:hover {
          background: linear-gradient(135deg, #1565C0, #1976D2);
           text-decoration: none;
  
        }

        .geo-pin-icon {
          width: 20px;
          height: 20px;
        }

        /* Responsive Styles for smaller screens */
        @media (max-width: 1100px) {
          .main-content-wrapper {
            flex-direction: column;
            align-items: center;
          }

          .tabs {
            max-width: 100%;
            width: 100%;
            min-width: auto;
          }

          .tab-content-container {
            height: 300px;
          }

          .geographic-location-card {
            flex: 0 0 auto;
            width: 100%;
            max-width: 600px;
            min-width: auto;
            height: 460px;
          }

          .geo-map-container {
            height: auto;
          }
        }

        @media (max-width: 768px) {
          .kcontainer {
            padding: 15px;
          }

          .whats-new-heading {
            font-size: 28px;
            margin-bottom: 25px;
          }

          .main-content-wrapper {
            gap: 20px;
          }

          .tabs {
            margin: 0;
          }

          .tab-buttons {
            flex-wrap: nowrap;
            padding: 10px 0;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
          }

          .tab-buttons button {
            margin: 0 5px;
            font-size: 12px;
            padding: 8px 10px;
          }

          .tab-content-container {
            height: 300px;
          }

          .view-more {
            font-size: 12px;
            padding: 6px 12px;
          }

          .geographic-location-card {
            max-width: 100%;
          }

          .geo-header {
            font-size: 20px;
            padding: 15px 20px;
          }

          .geo-map-container {
            padding: 18px;
            height: auto;
          }

          .geo-pointer {
            font-size: 12px;
            padding: 8px 14px;
          }

          .geo-area {
            font-size: 16px;
            padding: 12px 20px;
          }

          .geo-locate-btn {
            font-size: 16px;
            padding: 12px 20px;
          }
        }

        @media (max-width: 480px) {
          .kcontainer {
            padding: 10px;
          }

          .whats-new-heading {
            font-size: 24px;
            margin-bottom: 20px;
            background-size: 80px 2px;
          }

          .tab-buttons button {
            font-size: 11px;
            padding: 6px 8px;
          }

          .tab-item p strong {
            font-size: 13px;
          }

          .view-more {
            font-size: 11px;
            padding: 5px 10px;
          }

          .geo-header {
            font-size: 18px;
            padding: 12px 15px;
          }

          .geo-map-container {
            padding: 16px;
            height: auto;
          }

          .geo-pin-icon {
            width: 18px;
            height: 18px;
          }
        }
      `}</style>
    </div>
  );
}

export default Tabs;
